import { useState } from 'react';
import { request } from '../lib/api';
type Writer={write(value:Uint8Array|string):Promise<void>;close():Promise<void>;abort():Promise<void>};
type Folder={getFileHandle(name:string,options:{create:boolean}):Promise<{createWritable():Promise<Writer>}>};
export function ManualLaptopBackup(){
  const [busy,setBusy]=useState(false),[message,setMessage]=useState('');
  async function save(){
    const picker=(window as unknown as {showDirectoryPicker?: (options:{mode:string})=>Promise<Folder>}).showDirectoryPicker;
    if(!picker){setMessage('Use desktop Chrome or Edge to select a local backup folder.');return;}
    let output:Writer|undefined;
    setBusy(true);
    try{
      const folder=await picker({mode:'readwrite'});
      const job=await request<{stamp:string;files:{name:string;token:string;url:string}[]}>('/api/backups/manual',{method:'POST'});
      const files=[];
      for(const file of job.files){
        setMessage(`Preparing ${file.name}… Keep this tab open.`);
        const response=await fetch(file.url);
        if(!response.ok || !response.body)throw new Error('Backup could not start. Please retry.');
        output=await (await folder.getFileHandle(file.name,{create:true})).createWritable();
        const reader=response.body.getReader();let bytes=0;
        try{
          for(;;){const {done,value}=await reader.read();if(done)break;await output.write(value);bytes+=value.length;setMessage(`Saving ${file.name}: ${(bytes/1048576).toFixed(1)} MB`);}
          const result=await request<{state:string;bytes:number;sha256:string}>(`/api/backups/manual/${file.token}`);
          if(result.state!=='complete' || result.bytes!==bytes)throw new Error('Backup interrupted. This file is not complete; retry the backup.');
          await output.close();output=undefined;
          files.push({name:file.name,bytes,sha256:result.sha256});
        }finally{await reader.cancel().catch(()=>undefined);}
      }
      output=await (await folder.getFileHandle(`backup-${job.stamp}.json`,{create:true})).createWritable();
      await output.write(JSON.stringify({version:1,stamp:job.stamp,files,savedAt:new Date().toISOString(),note:'Database and application only. Original uploaded files are not included. Verify SHA-256 before restore.'},null,2));
      await output.close();output=undefined;
      setMessage('Backup saved with checksum manifest. No backup files were stored on the server. Keep this folder private.');
    }catch(error){await output?.abort().catch(()=>undefined);setMessage(error instanceof Error?error.message:'Backup failed.');}
    finally{setBusy(false);}
  }
  return <div><button type="button" className="primary-button" disabled={busy} onClick={()=>void save()}>{busy?'Saving backup…':'Save new backup to laptop folder'}</button>{message&&<p role="status">{message}</p>}</div>;
}
